import script from "./SeatQuery.vue?vue&type=script&setup=true&lang=js"
export * from "./SeatQuery.vue?vue&type=script&setup=true&lang=js"

import "./SeatQuery.vue?vue&type=style&index=0&id=010185e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-010185e4"]])

export default __exports__